// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"485":"0c5254f5","586":"25d078da","805":"e93ac525","825":"dce1d08f"}[chunkId] + ".chunk.js";
};